var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-3 campaign-media-option",class:_vm.active ? 'active-option' : '',attrs:{"flat":"","color":"#F1F4F9"},on:{"click":_vm.selectMedia}},[_c('img',{attrs:{"src":require(`../../../assets/${_vm.image}.svg`)}})]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }